export function loadScript(src: string, id?: string, async?: boolean) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    if (id) {
      script.id = id
    }

    script.src = src
    if (async) {
      script.setAttribute('async', '')
    }

    script.onload = resolve
    script.onerror = reject
    document.getElementsByTagName('head')[0].appendChild(script)
  })
}

export function getByTextContent(container: HTMLElement | Document, text: string): HTMLElement {
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (node) => {
      if (node.textContent === text) {
        return NodeFilter.FILTER_ACCEPT
      }

      return NodeFilter.FILTER_SKIP
    },
  })

  let node: Node | null = walker.currentNode
  let lastNode: Node | null = null
  while (true) {
    node = walker.nextNode()
    if (node) {
      lastNode = node
    } else {
      break
    }
  }

  return lastNode as HTMLElement
}
